module.exports = __webpack_public_path__ + "static/media/floral.4940616b.svg";